export const createExportSizeLabel = (exportSizeValue: string) =>
  exportSizeValue
    .split(' ')
    .map((size: string) => size.replace('in', '″'))
    .join(' × ');
